<template>
  <el-dialog
    :title="$t('chooseReportCustomComponent.chooseReportComponent')"
    :visible.sync="dialogVisible"
    width="80%"
    top="5vh">
    <el-row>
      <el-col :span="24">
        <el-card>
          <div class="card-body">
            <el-row :gutter="20" style="margin-bottom: 20px;">
              <el-col :span="18"></el-col>
              <el-col :span="6">
                <el-input-group>
                  <el-input
                    v-model="chooseReportCustomComponentInfo._currentReportCustomComponentName"
                    :placeholder="$t('chooseReportCustomComponent.inputComponentName')"
                    size="small">
                  </el-input>
                  <el-button 
                    slot="append" 
                    type="primary" 
                    size="small"
                    @click="queryReportCustomComponents()">
                    {{$t('chooseReportCustomComponent.search')}}
                  </el-button>
                </el-input-group>
              </el-col>
            </el-row>
            <el-table
              :data="chooseReportCustomComponentInfo.reportCustomComponents"
              border
              style="width: 100%">
              <el-table-column
                prop="componentId"
                :label="$t('chooseReportCustomComponent.componentId')"
                align="center">
              </el-table-column>
              <el-table-column
                prop="name"
                :label="$t('chooseReportCustomComponent.componentName')"
                align="center">
              </el-table-column>
              <el-table-column
                prop="componentType"
                :label="$t('chooseReportCustomComponent.componentType')"
                align="center">
              </el-table-column>
              <el-table-column
                prop="queryModel"
                :label="$t('chooseReportCustomComponent.queryModel')"
                align="center">
              </el-table-column>
              <el-table-column
                prop="remark"
                :label="$t('chooseReportCustomComponent.description')"
                align="center">
              </el-table-column>
              <el-table-column
                :label="$t('chooseReportCustomComponent.operation')"
                align="center">
                <template slot-scope="scope">
                  <el-button
                    size="mini"
                    type="primary"
                    @click="chooseReportCustomComponent(scope.row)">
                    {{$t('chooseReportCustomComponent.choose')}}
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              @current-change="handleCurrentChange"
              :current-page="pagination.currentPage"
              :page-size="10"
              layout="total, prev, pager, next"
              :total="pagination.total"
              style="margin-top: 20px;">
            </el-pagination>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </el-dialog>
</template>

<script>
import { listReportCustomComponent } from '@/api/dev/reportCustomComponentApi'

export default {
  name: 'ChooseReportCustomComponent',
  data() {
    return {
      dialogVisible: false,
      chooseReportCustomComponentInfo: {
        reportCustomComponents: [],
        _currentReportCustomComponentName: '',
        _curParam: {}
      },
      pagination: {
        currentPage: 1,
        total: 0
      }
    }
  },
  methods: {
    open(params) {
      this.chooseReportCustomComponentInfo._curParam = params
      this.dialogVisible = true
      this._refreshChooseReportCustomComponentInfo()
      this._loadAllReportCustomComponentInfo(1, 10, '')
    },
    async _loadAllReportCustomComponentInfo(page, row, name) {
      try {
        const res = await listReportCustomComponent({
          page: page,
          row: row,
          name: name
        })
        this.chooseReportCustomComponentInfo.reportCustomComponents = res.data
        this.pagination.total = res.records
        this.pagination.currentPage = page
      } catch (error) {
        console.error('请求失败处理', error)
      }
    },
    chooseReportCustomComponent(row) {
      Object.assign(this.chooseReportCustomComponentInfo._curParam, row)
      this.dialogVisible = false
    },
    queryReportCustomComponents() {
      this._loadAllReportCustomComponentInfo(
        1, 
        10, 
        this.chooseReportCustomComponentInfo._currentReportCustomComponentName
      )
    },
    _refreshChooseReportCustomComponentInfo() {
      this.chooseReportCustomComponentInfo._currentReportCustomComponentName = ""
    },
    handleCurrentChange(val) {
      this._loadAllReportCustomComponentInfo(
        val, 
        10, 
        this.chooseReportCustomComponentInfo._currentReportCustomComponentName
      )
    }
  }
}
</script>

<style scoped>
.card-body {
  padding: 20px;
}
</style>